// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".payment-icon[data-v-0e048b6b]{width:45px;height:45px;object-fit:contain}[data-v-0e048b6b] .billing-card .card-header{color:#333;background-color:#f5f5f5 !important;border-bottom:1px solid #ddd !important;padding:.5rem !important}[data-v-0e048b6b] .billing-card .card-body{padding:.5rem !important}", ""]);
// Exports
module.exports = exports;
